<br>
  <div class="p-grid">
    <div class="p-col-45">
      <h4>Priority Level Information</h4>
    </div>
  </div>
  <br>
    <form id="priorityLevelForm" #priorityLevelForm="ngForm">
      <div class="p-grid">
        <div class="p-col-6">
          <h6>Priority Level Name</h6>
          <input pInputText fluid #priorityNameInput name="status" [(ngModel)]="priority.status" [disabled]="saving" required/>
        </div>
        <div class="p-col-2">
          <h6>Color</h6>
          <input pInputText fluid readonly name="color" [(colorPicker)]="color" [cpOutputFormat]="'hex'" [style.background]="color" [disabled]="saving" required/>
        </div>
        <div class="p-col-2">
          <h6>Order</h6>
          <input type="number" pInputText fluid name="order" [(ngModel)]="priority.order" [disabled]="saving" required/>
        </div>
      </div>
      <div class="p-grid">
        <div class="p-col-2">
          <h6>Start Date</h6>
          <p-datepicker
            [style]="{'width': '100%'}"
            name="startDate"
            class="calendar-picker"
            [placeholder]="'Start Date'"
            [(ngModel)]="priority.startDate"
            [inputStyle]="{'width':'100%'}"
            [disabled]="saving"
            [maxDate]="priority.endDate"
            oninput="validity.valid||(value='');"
            [showButtonBar]="true"
            >
          </p-datepicker>
        </div>
        <div class="p-col-2">
          <h6>End Date</h6>
          <p-datepicker
            [style]="{'width': '100%'}"
            name="endDate"
            class="calendar-picker"
            [placeholder]="'End Date'"
            [(ngModel)]="priority.endDate"
            [inputStyle]="{'width':'100%'}"
            [minDate]="priority.startDate"
            [disabled]="saving"
            oninput="validity.valid||(value='');"
            [showButtonBar]="true"
            >
          </p-datepicker>
        </div>
      </div>
      <div class="p-grid">
        <div class="p-col-12 columnPadding">
          @if (priorityLevelForm.invalid && priorityLevelForm.submitted) {
            <div class="alert alert-danger" role="alert">
              There are errors on this page. Please correct the errors and resubmit.
            </div>
          }
        </div>
        <div class="p-col-12" style="text-align: right">
          <p-button
            type="submit"
            (click)="savePriority(priorityLevelForm)"
            [disabled]="saving"
            severity="success"  
            label="Save">
          </p-button>
          <p-button 
            type="button"
            severity="warn"
            (click)="clear(priorityLevelForm);"
            label="Clear">
          </p-button>
        </div>
      </div>
    </form>
    <br>
      <br>
        <p-table showGridlines stripedRows responsiveLayout="stack" [columns]="cols" [value]="priorities" [paginator]="true" [rows]="30"
          [loading]="isLoading">
          <ng-template pTemplate="header" let-columns>
            <tr>
              @for (col of columns; track col) {
                <th [pSortableColumn]="col.field" [style.width]="col.width">
                  {{col.header}}
                  @if (col.header != '') {
                    <p-sortIcon [field]="col.field" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                  }
                </th>
              }
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-priority
            let-columns="columns"
            let-rowIndex="rowIndex">
            <tr>
              <td><span class="p-column-title">{{columns[0].header}}</span>{{priority.status}}</td>
              <td [ngStyle]="{'background-color': priority.backgroundColor}"><span class="p-column-title">{{columns[1].header}}</span></td>
              <td><span class="p-column-title">{{columns[2].header}}</span>{{priority.order}}</td>
              <td>
                <span class="p-column-title">{{columns[3].header}}</span>
                @if (priority.startDate) {
                  <span>{{priority.startDate | date: 'shortDate'}}</span>
                }
                @if (!priority.startDate) {
                  <span class="fine-print">No start date</span>
                }
              </td>
              <td>
                <span class="p-column-title">{{columns[4].header}}</span>
                @if (priority.endDate) {
                  <span>{{priority.endDate | date: 'shortDate'}}</span>
                }
                @if (!priority.endDate) {
                  <span class="fine-print">No end date</span>
                }
              </td>
              <td>
                <p-button
                  
                  type="button"
                  icon="pi pi-pencil"
                  (click)="editPriority(priority)"
                  severity="info" >
                </p-button>
                <!-- GO BACKS ARE ID 1 AND ARE PROTECTED FROM DELETE -->
                <p-button
                  
                  type="button"
                  icon="pi pi-trash"
                  (click)="deletePriority(priority)"
                  [disabled]="priority.id == 1"
                  severity="danger">
                </p-button>
              </td>
            </tr>
          </ng-template>
        </p-table>
        <br>

